import Bowser from "bowser";

function composeBrowerString(o) {
return `Navigator: ${o.userAgent},
Browser: ${o.browser.name} ${o.browser.version},
Engine: ${o.engine.name},
OS: ${o.os.name} ${o.os.version},
Platform: ${o.platform.type} ${o.platform.vendor}`
}

export function detectBrowser(debug) {
  const userAgent = window.navigator.userAgent;
  const result = Bowser.getParser(userAgent);
  const { browser, engine, os, platform } = result.parsedResult;
  document.documentElement.classList.add(browser.name);
  document.documentElement.classList.add(engine.name);
  document.documentElement.classList.add(os.name);
  document.documentElement.classList.add(platform.type);
  document.documentElement.setAttribute('data-browser', browser.name);
  document.documentElement.setAttribute('data-browser-version', browser.version);
  document.documentElement.setAttribute('data-engine', engine.name);
  document.documentElement.setAttribute('data-os', os.name);
  document.documentElement.setAttribute('data-os-version', os.version);
  document.documentElement.setAttribute('data-platform', platform.type);
  const o = {
    ...result.parsedResult,
    userAgent: userAgent,
  }
  if (debug) {
    console.log(o);
    const el = document.createElement('pre');
    el.innerHTML = composeBrowerString(o);
    el.style.backgroundColor = 'rgba(255,255,255,.85)';
    el.style.zIndex = '1000';
    el.style.position = 'fixed';
    el.style.top = '10px';
    el.style.left = '10px';
    document.body.prepend(el);
  }
  return o
}

export default detectBrowser;